export function generateBlobUrlWithHtml(htmlContent: string): string {
  const blob = new Blob([htmlContent], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  return url;
}
